import { useCallback } from 'react';
import { useParams } from 'react-router';
import { type GetCommentParams, getPartnerProposalComments, postComment } from '@/api/comments';
import Comments from '@/components/Comments';
import { useDraw } from '@/hooks/ReactQueryHooks/useProjectDrawQuery';
import DrawDetailsHeader from './components/DrawDetailsHeader';
import { DocumentsList } from './Documents';
import { InvoicesList } from './Invoices';

export const DrawDetails = () => {
  const { projectId, drawId } = useParams();

  const fetchDraw = useDraw({
    projectId: Number(projectId),
    drawId: Number(drawId),
  });
  const draw = fetchDraw?.data?.data;

  const postComments = useCallback(
    async (values: { comment: string }) => {
      const response = await postComment({
        data: {
          resource_id: drawId!,
          resource_type: 'ProjectDraw',
          ...values,
        },
      });
      return response;
    },
    [drawId]
  );

  const getComments = useCallback(
    (_params: GetCommentParams) => {
      return getPartnerProposalComments({
        params: {
          resource_id: drawId!,
          resource_type: 'ProjectDraw',
        },
      });
    },
    [drawId]
  );

  return (
    <>
      <DrawDetailsHeader />
      <div className='mt-7 w-full shadow-lg z-10'>
        <DocumentsList />
      </div>
      <div className='my-7 w-full shadow-lg z-10'>
        <InvoicesList
          totalInvoiceAmount={draw?.totalSubmittiedInvoiceAmount ?? 0}
          totalInvoiceApprovedAmount={draw?.totalApprovedInvoiceAmount ?? 0}
        />
      </div>
      <Comments getComments={getComments} postComments={postComments} queryKey='draw-comments' />
    </>
  );
};
